import { useTranslate } from '../../../utils/translate'
import FormGroup from '../../formComponents/FormGroup'

type PageModalCategoryManagementProps = {
  adminUrl?: string
}

export default function PageModalCategoryManagement({ adminUrl }: Readonly<PageModalCategoryManagementProps>) {
  const scope = 'components.editorSidebarComponent.pageManagerSection.categoriesSection.pageSettingsModal'

  const t = useTranslate('interface')

  if (!adminUrl) return null

  return (
    <FormGroup key="categoryMgmt" name="products" label={t(`${scope}.manageCategorySection.title`)}>
      <p className="ep-form-row-text">
        <a className="ep-form-row-text-link" href={`${adminUrl}&ViewAction=UnityMBO-ViewProducts`} target="_parent">
          {t(`${scope}.manageCategorySection.assignProductsLink`)}
        </a>
        &nbsp;
        {t(`${scope}.manageCategorySection.or`)}
        &nbsp;
        <a className="ep-form-row-text-link" href={`${adminUrl}&ViewAction=UnityMBO-ViewChildObjects`} target="_parent">
          {t(`${scope}.manageCategorySection.manageSubCategoriesLink`)}
        </a>
      </p>
    </FormGroup>
  )
}
